<li class="nav-item"
	*ngFor="let menuitem of menuItems.getAll()"
	[ngClass]="{'open-menu': selectedMenu == menuitem.name}"
	[routerLinkActive]="['nav-item--active']">
	<a class="nav-link text-center px-xl-4"
	   [routerLink]="['/', menuitem.state]"
	   *ngIf="menuitem.type === 'link'">{{ menuitem.name }}</a>
	<a class="nav-link text-center px-xl-4"
	   [href]="menuitem.link"
	   *ngIf="menuitem.type === 'reroute'">{{ menuitem.name }}</a>
</li>
<li class="nav-item d-flex justify-content-center d-xl-none">
	<a *ngIf="!isUserLogged"
	   [routerLink]="['/account/login']"
	   class=" btn btn-primary btn-primary--small mt-4 mt-xl-0"> Zaloguj się </a>
</li>
<!-- <nav id="navigation" class="style-1">
  <ul id="responsive">
     <li *ngFor="let menuitem of menuItems.getAll()" [ngClass]="{'open-menu': selectedMenu == menuitem.name}">
        <a class="current" [routerLink]="['/', menuitem.state]"
           *ngIf="menuitem.type === 'link'">{{ menuitem.name }}</a>
        <a class="current" *ngIf="menuitem.type === 'sub'" (click)="menuClick(menuitem.name)">{{ menuitem.name }}</a>
        <ul *ngIf="menuitem.type === 'sub'">
           <li *ngFor="let childitem of menuitem.children"
              [ngClass]="{'open-menu': selectedSubMenu == childitem.name}">
              <a [routerLink]="['/', menuitem.state, childitem.state ]"
                 *ngIf="childitem.type === 'link'">{{ childitem.name }}</a>
              <a *ngIf="childitem.type === 'sub'" (click)="subMenuClick(childitem.name)">{{ childitem.name }}</a>
              <ul *ngIf="childitem.type === 'sub'">
                 <li *ngFor="let subchilditem of childitem.children">
                    <a
                       [routerLink]="['/', menuitem.state, childitem.state, subchilditem.state ]">{{ subchilditem.name }}</a>
                 </li>
              </ul>
           </li>
        </ul>
     </li>
     <li><a *ngIf="!isUserLogged" [routerLink]="['/account/login']"
           class="btn btn-neutral btn-icon btn-radius loginBtn">Zaloguj się</a></li>
  </ul>
</nav> -->
